import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import styles from './toastr.scss';

export const ToastrManagerComponent = props => (
  <ReduxToastr
    className={styles.container}
    timeOut={3000}
    preventDuplicates
    position="top-right"
    transitionIn="fadeIn"
    transitionOut="fadeOut"
    {...props}
  />
);

export default ToastrManagerComponent;
